import anime from 'animejs';

import { CLASSES, SELECTORS, DATA_ATTR } from '../config/constants';

class TabController {
  constructor(tabListElem) {
    this.tabListEl = tabListElem;
    this.staggerTimeout = tabListElem.dataset.staggerTimeout;
  }

  init(activeItem) {
    const firstListItem = this.tabListEl.querySelector(SELECTORS.TAB.LIST_SWITCH);

    this.setActiveTab(activeItem || firstListItem);
    this.watchActiveItemChange();
  }

  setActiveTab(listItem) {
    const tabContent = this.getTabContent(listItem);
    const listsToAnimate = tabContent?.querySelectorAll?.(`ul:not([data-${DATA_ATTR.TAB.ANIMATE}="false"])`);


    this.removeActiveTabs();

    listItem.classList.add(CLASSES.TAB.ACTIVE);

    if (tabContent) {
      tabContent.classList.add(CLASSES.TAB.ACTIVE);
    }

    if (listsToAnimate && listsToAnimate.length) {
      listsToAnimate.forEach((listEl) => {
        const itemsToAnimate = listEl.querySelectorAll(':scope > li');

        this.animateItems({ targets: itemsToAnimate });
      });
    }
  }

  removeActiveTabs() {
    const listItems = this.tabListEl.querySelectorAll(SELECTORS.TAB.LIST_SWITCH);

    if (!listItems) {
      return;
    }

    listItems.forEach((listItem) => {
      const tabContent = this.getTabContent(listItem);

      listItem.classList.remove(CLASSES.TAB.ACTIVE);

      if (tabContent) {
        tabContent.classList.remove(CLASSES.TAB.ACTIVE);
      }
    });
  }

  getTabContent(listItem) {
    const { tabContentSelector } = listItem.dataset;

    if (!tabContentSelector) {
      return;
    }

    return document.querySelector(tabContentSelector);
  }

  watchActiveItemChange() {
    this.tabListEl.addEventListener('click', ({ target }) => {
      const isListItem = target.classList.contains(CLASSES.TAB.LIST_SWITCH);
      const isActiveItem = target.classList.contains(CLASSES.TAB.ACTIVE);

      if (!isListItem || isActiveItem) {
        return;
      }

      this.setActiveTab(target);
    });
  }

  animateItems({ targets }) {
    anime({
      targets,
      opacity: 0,
      translateY: 10,
      duration: 0,
    });

    anime({
      targets,
      translateY: 0,
      opacity: 1,
      delay: anime.stagger(this.staggerTimeout || 25),
    });
  }
}

export default TabController;
